'use strict';

/**
 * Filter component view
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var FilterComponentView = require('modules/base/views/layout/filter-component');

var template = require('modules/collection/templates/components/filter/cataloging-date.hbs');

var CatalogingDateView = FilterComponentView.extend({
    template: template,
});

module.exports = CatalogingDateView;